import { SVGProps, Ref, forwardRef } from 'react'
const SvgPassCode = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    width="1.5rem"
    height="1.5rem"
    fill="none"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <path
      stroke="currentColor"
      strokeWidth={1.5}
      d="M2 2.918a1.918 1.918 0 1 0 3.836 0 1.918 1.918 0 0 0-3.836 0ZM9.984 2.918a1.918 1.918 0 1 0 3.836 0 1.918 1.918 0 0 0-3.836 0ZM19.883 4.836a1.918 1.918 0 1 0 0-3.836 1.918 1.918 0 0 0 0 3.836ZM3.918 6.91a1.918 1.918 0 1 0 0 3.836 1.918 1.918 0 0 0 0-3.837ZM11.903 6.91a1.918 1.918 0 1 0-.001 3.836 1.918 1.918 0 0 0 .001-3.837ZM19.883 6.91a1.919 1.919 0 1 0 0 3.836 1.919 1.919 0 0 0 0-3.837ZM3.918 12.819a1.918 1.918 0 1 0 0 3.835 1.918 1.918 0 0 0 0-3.835ZM11.903 12.819a1.918 1.918 0 1 0-.001 3.836 1.918 1.918 0 0 0 .001-3.836ZM9.984 20.646a1.918 1.918 0 1 0 3.836 0 1.918 1.918 0 0 0-3.836 0ZM19.883 12.819a1.918 1.918 0 1 0 0 3.835 1.918 1.918 0 0 0 0-3.835Z"
    />
  </svg>
)
const ForwardRef = forwardRef(SvgPassCode)
export default ForwardRef
